import { articleSlice } from "./articleSlice";
import * as actions from "./articleActions";
import * as selectors from "./articleSelectors";

export { actions };
export { selectors };
export default articleSlice.reducer;
